import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Center } from '@chakra-ui/react';
import { Buffer } from 'buffer';

import SignupForm from 'src/components/AuthForms/SignupForm';
import LoginForm from 'src/components/AuthForms/LoginForm';
import RecoveryForm from 'src/components/AuthForms/RecoveryForm';
import { EllipsisLoading } from 'src/components/loadings';
import { useMeQuery } from 'src/hooks/queries/user';

import { useCartStore } from '../stores';
import CompleteSingupForm from 'src/components/AuthForms/CompleteSingupForm';
import { useUserStore } from 'src/hooks/stores';
import { useEventHistory } from '../hooks';

const Sections = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  RECOVERY: 'recovery',
  COMPLETE_SINGUP: 'completeSingup',
};

const CheckoutLogin = () => {
  const { eventID } = useParams();
  const navigator = useNavigate()
  const eventHistory = useEventHistory();
  const {data, isSuccess} = useMeQuery()
  const { setEventCart, getEventCart } = useCartStore();
  const { userStatus } = useUserStore();
  const [view, navigate] = React.useState(Sections.LOGIN);
  const isUserLogged = isSuccess && data.email;
  const url = new URL(window.location.href);
  const ticketsParam = url.searchParams.get('tickets');

  const onLogIn = React.useCallback(async () => {
    const currentCart = getEventCart(eventID!);
    const hasTickets = currentCart.some(item => item.quantity > 0);

    if (hasTickets) {
      const searchParams = new URLSearchParams(window.location.search);
      const searchParamsData = searchParams.toString() ? '?' + searchParams.toString() : '';
      try {
        navigator(`/event/${eventID}/checkout/payment${searchParamsData}`);
      } catch (err) {
        navigator(`/event/${eventID}/checkout/open-error${searchParamsData}`);
      }
    }
  }, [eventID, getEventCart, navigator]);

  React.useEffect(() => {
    if (ticketsParam) {
      try {
        const tickets = JSON.parse(Buffer.from(ticketsParam, 'base64').toString('utf-8'));

        if (tickets) {
          setEventCart(eventID!, tickets);
          url.searchParams.delete('tickets')
          const validPath = url.href.split(".br")[1]
          sessionStorage.setItem("userStatusValue", userStatus)
          eventHistory.push(validPath ?? "/")
        }

      } catch (error) {
        console.error('Erro ao decodificar os tickets da URL:', error);
      }
    }

  }, [eventHistory, eventID, setEventCart, ticketsParam, url.href, url.searchParams, userStatus]);

  React.useEffect(() => {
    if (isUserLogged) {
      onLogIn();
    }
  }, [isUserLogged, onLogIn, userStatus]);

  React.useEffect(() => {
    const userStatusValue = sessionStorage.getItem("userStatusValue")

    if(userStatusValue === 'pending') {
      const currentCart = getEventCart(eventID!);
      const hasTickets = currentCart.some(item => item.quantity > 0);

      if(hasTickets) {
        navigate(Sections.COMPLETE_SINGUP)
      } else {
        sessionStorage.removeItem("userStatusValue")
      }
    }
  }, [eventID, getEventCart, userStatus])

  React.useEffect(() => {
      const currentCart = getEventCart(eventID!);
      const hasTickets = currentCart.some(item => item.quantity > 0);

      if(!hasTickets) {
        eventHistory.push("tickets")
      }
  }, [eventHistory, eventID, getEventCart])

  if (isUserLogged && userStatus !== "pending") {
    return (
      <Center
        bg="white"
        position="absolute"
        top={0}
        left={0}
        right={0}
        h="100vh">
        <EllipsisLoading color="brand.500" />
      </Center>
    );
  }

  if (view === Sections.LOGIN) {
    return <LoginForm {...{ navigate, onLogIn }} />;
  }

  if (view === Sections.SIGNUP) {
    return <SignupForm {...{ navigate }} />;
  }

  if (view === Sections.RECOVERY) {
    return <RecoveryForm {...{ navigate }} />;
  }

  if (view === Sections.COMPLETE_SINGUP) {
    return <CompleteSingupForm {...{ navigate }} />;
  }

  return null;
};

export default CheckoutLogin;
